<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    closeable
    close-icon="close"
    style="min-height: 40%"
  >
    <div class="record">
      <div class="record_title mb_18 fs_20 text_center bold">奖励记录</div>
      <div v-if="!noRecord" class="record_item flex_center">
        <div class="record_left bold">时间</div>
        <div class="record_mid bold flex_1 m_0">获得奖励</div>
        <div class="record_right visible_hiden">---</div>
      </div>
      <div class="record_list">
        <van-empty
          v-if="noRecord"
          class="custom-image"
          image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
          description="暂无数据"
        />
        <div
          v-for="(it, idx) in list"
          :key="it.id"
          class="record_item flex_center mt_16"
          :class="{ mt_1: idx === 0 }"
        >
          <div class="record_left fs_15">
            <div class="record_time fs_13">
              {{ it.createTime }}
            </div>
          </div>
          <div class="record_mid flex_1 m_0">
            {{ it.rewardName }}
          </div>
          <div class="record_right">
            <div
              v-if="it.rewardType === 1"
              class="record_btn round flex_center"
              @click="goGiftFromRecord(it)"
            >
              {{ it.cdk ? '查看礼包' : '联系客服' }}
            </div>
            <div
              v-else-if="it.rewardType === 2"
              class="record_btn round flex_center"
              @click="goPointFromRecord(it)"
            >去使用积分</div>
            <div
              v-if="it.rewardType === 1 && !it.cdk"
              class="record_tip fs_10 mt_4"
            >
              兑换码生成错误
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Empty } from 'vant';
import { getZillianRewardRecord } from '@/apis/wxActivity'


export default {
  props: {
    activityId: {
      type: [String, Number],
      default: '',
    },
    activityGameId: {
      type: [String, Number],
      default: '',
    },
  },
  
  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
  },
  data () {
    return {
      visible: false,
      limitPoint: 0,
      list: [],
      noRecord: false,
      vloading: false,
    }
  },
  watch: {
    visible (f) {
      !f && this.$emit('close')
    },
  },
  methods: {
    triggerVisible (visible) {
      this.visible = visible;
      if (visible) {
        this.list = []
        this.onLoadList()
      }
    },
    onLoadList () {
      if (!this.visible) return
      this.getList();
    },
    getList () {
      this.vloading = true
      getZillianRewardRecord({
        activityId: this.activityId,
        activityGameId: this.activityGameId,
      }).then(res => {
        this.list = res.data || []
        this.noRecord = !this.list.length
      }).finally(() => {
        this.vloading = false
      })
    },
    genWels (wel) {
      const { rewardType, rewardId, rewardName } = wel || {}
      if (rewardType === 3) return `掷骰子次数+${rewardId}`
      if ([2, 1].includes(rewardType)) return rewardName
    },
    goGiftFromRecord (it) {
      this.$emit('goGift', it)
    },
    goPointFromRecord (it) {
      this.$emit('goPoint', it)
    },
  },
}
</script>

<style lang="scss" scoped>
.record {
  height: 100%;
  padding: 26px 24px 16px;
  color: #000;
  .record_list {
    max-height: 280px;
    overflow: auto;
    margin-top: 12px;
  }
  .record_subtitle {
    padding: 8px 4px 8px 12px;
    border-bottom: 1px solid #ededed;
    margin-bottom: 12px;
  }
  .record_item {
    .record_left {
      text-align: center;
      width: 80px;
      margin-right: 12px;
    }
    .record_mid {
      text-align: center;
    }
    .record_right {
      text-align: center;
      width: 72px;
    }
  }
  .record_btn {
    width: 66px;
    height: 26px;
    font-size: 10px;
    background-color: #F7502A;
    color: #fff;
  }
  .record_tip {
    color: #F7502A;
  }
}
</style>